@if (busyMessageManager.count()) {
    <ws-busy-indicator [message]="busyMessageManager.message"></ws-busy-indicator>
}

<div class="card panel-flat-color primary-panel ws-flex-auto m-0 d-flex flex-column">
    <div class="panel-flat-header">
        <div class="float-start">
            <h3 helpTooltip
                helpContentId="filing-batch-info.panel"
                position="bottom">
                Filing Batch Info
            </h3>
        </div>
        <div class="float-end header-button-container d-flex">
            <div class="action-button-wrapper"
                 helpTooltip
                 [helpContentId]="editHelpContentId"
                 position="bottom">
                @if (canEdit() && !editMode()) {
                    <button type="button"
                            class="ace-btn btn-text has-icon btn-primary"
                            [disabled]="!canEnterEditMode"
                            (click)="edit()">
                        <i class="fa fa-pencil fa-align"></i>
                    </button>
                }
            </div>
            <div class="action-button-wrapper">
                @if (editMode()) {
                    <button type="button"
                            class="ace-btn btn-text has-icon btn-primary"
                            [disabled]="!formValid()"
                            (click)="save()"
                            helpTooltip
                            helpContentId="app.save"
                            position="bottom">
                        <i class="fa fa-save fa-align"></i>
                    </button>
                }
            </div>
            <div class="action-button-wrapper">
                @if (editMode()) {
                    <button type="button"
                            class="ace-btn btn-text has-icon btn-primary"
                            (click)="cancel()"
                            helpTooltip
                            helpContentId="app.cancel"
                            position="bottom">
                        <i class="fa fa-times fa-align"></i>
                    </button>
                }
            </div>
            <div class="action-button-wrapper"
                 helpTooltip
                 helpContentId="app.expand"
                 position="bottom">
                @if (!isExpanded) {
                    <button type="button"
                            class="ace-btn btn-text has-icon btn-secondary"
                            (click)="expandComponent()">
                        <i class="fa fa-arrows-alt"></i>
                    </button>
                }
            </div>
            <div class="action-button-wrapper"
                 helpTooltip
                 helpContentId="app.collapse"
                 position="bottom">
                @if (isExpanded) {
                    <button type="button"
                            class="ace-btn btn-text has-icon btn-secondary"
                            (click)="collapseComponent()">
                        <i class="fa fa-compress"></i>
                    </button>
                }
            </div>
        </div>
    </div>
    <div class="panel-flat-body ws-flex-auto d-flex flex-column mt-4 justify-content-center">
        <filing-batch-info
            [filingBatch]="displayModel()"
            [editMode]="editMode()"
            (formValidityChanged)="formValid.set($event)"
            (filingBatchChange)="onFilingBatchChange($event)">
        </filing-batch-info>

        @if (editMode() && !isReadOnly) {
            <div class="actions">
                <button type="button"
                        class="ace-btn btn-primary btn-danger btn-sm float-end"
                        (click)="delete()"
                        helpTooltip
                        helpContentId="app.delete"
                        position="bottom">
                    Delete
                </button>
            </div>
        }
    </div>
</div>



